import axios, {AxiosResponse} from 'axios'
import {AdvertisingQueryResponse, ElementModel, elementType} from './_models'
import {ID, Response} from "../../../../../_metronic/helpers";

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/api/v1/Element`
const GET_USERS_URL = `${API_URL}/api/v1/Element/Get`

const getUsers = (query: string): Promise<AdvertisingQueryResponse> => {
    return axios
        .get(`${GET_USERS_URL}?${query}`)
        .then((d: AxiosResponse<AdvertisingQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<ElementModel | undefined> => {
    return axios
        .get(`${USER_URL}/${id}`)
        .then((response: AxiosResponse<Response<ElementModel>>) => response.data)
        .then((response: Response<ElementModel>) => response.data)
}

const createUser = (user: ElementModel,file : any,list : number[] , listProductCat:number[]): Promise<ElementModel | undefined> => {
    const fd = new FormData();
    fd.append('Title', user.title || '');
    fd.append('Description', user.description || '');
    fd.append('PicName', user.picName || '');
    fd.append('Take', user.take!.toString() || '');
    fd.append('Content', user.content || '');
    fd.append('PostSortBy', user.postSortBy!.toString() || '');
    fd.append('PostTakeModel', user.postTakeModel!.toString() || '');
    fd.append('ElementType', user.elementType!.toString() || '');
    if(user.elementType == elementType.post){
        list.forEach(item =>{
            fd.append('catList[]', item!.toString() || '');

        })
    }
    if(user.elementType == elementType.product) {
        listProductCat.forEach(item => {
            fd.append('productCatList[]', item!.toString() || '');

        })
    }
    if(file != null)
        fd.append('File', file,file.name);

    return axios
        .post(`${USER_URL}`,fd)
        .then((response: AxiosResponse<Response<ElementModel>>) => response.data)
        .then((response: Response<ElementModel>) => response.data)
}

const updateUser = (user: ElementModel,file : any,list : number[], listProductCat:number[]): Promise<ElementModel | undefined> => {
    const fd = new FormData();
    console.log(listProductCat)
    fd.append('Title', user.title || '');
    fd.append('Description', user.description || '');
    fd.append('PicName', user.picName || '');
    fd.append('Take', user.take!.toString() || '');
    fd.append('Content', user.content || '');
    fd.append('PostSortBy', user.postSortBy!.toString() || '');
    fd.append('PostTakeModel', user.postTakeModel!.toString() || '');
    fd.append('ElementType', user.elementType!.toString() || '');
    if(user.elementType == elementType.post){
        list.forEach(item =>{
            if(item != 0)
                fd.append('catList[]', item!.toString() || '');

        })
    }
    if(user.elementType == elementType.product) {
        listProductCat.forEach(item => {
            if(item != 0)
                fd.append('productCatList[]', item!.toString() || '');

        })
    }
    if(file != null)
        fd.append('File', file,file.name);

    return axios
        .put(`${USER_URL}/${user.id}`,fd)
        .then((response: AxiosResponse<Response<ElementModel>>) => response.data)
        .then((response: Response<ElementModel>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
    return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
    const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
    return axios.all(requests).then(() => {})
}

export {
    getUsers,
    deleteUser,
    deleteSelectedUsers,
    getUserById,
    createUser,
    updateUser,
}

